import { render } from "./passRateTable.vue?vue&type=template&id=606d2efe&scoped=true"
import script from "./passRateTable.vue?vue&type=script&lang=js"
export * from "./passRateTable.vue?vue&type=script&lang=js"

import "./passRateTable.vue?vue&type=style&index=0&id=606d2efe&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606d2efe"]])

export default __exports__